/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {SidebarMenuItem} from './SidebarMenuItem'
import RoleBaseGuard from '../../../elements/RoleBaseGuard'

const SidebarMenuMain = () => {
  const intl = useIntl()

  return (
    <>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-4 ls-1'>opciones</span>
        </div>
      </div>
      <SidebarMenuItem
        to='/upload-file'
        icon={'/media/soyfri-media/document.svg'}
        title='Nuevo pago fri'
      />
      <SidebarMenuItem
        to='/errors'
        icon={'/media/icons/duotune/files/fil007.svg'}
        title='Pagos con error'
      />
      <SidebarMenuItem
        to='/scheduled'
        icon={'/media/soyfri-media/calendar.svg'}
        title='Pagos programados'
      />
      <SidebarMenuItem
        to='/history'
        icon={'/media/soyfri-media/clock.svg'}
        title='Pagos realizados'
      />
      <RoleBaseGuard permission='list_user'>
        <SidebarMenuItem
          to='/user-managment/list'
          icon={'/media/soyfri-media/users.svg'}
          title='Administración usuarios'
        />
      </RoleBaseGuard>
      <SidebarMenuItem
        to='/profile'
        icon={'/media/soyfri-media/NavBar_icons.svg'}
        title='Perfil'
      />
    </>
  )
}

export {SidebarMenuMain}
